import { render, staticRenderFns } from "./AddIssue.vue?vue&type=template&id=5378f150&"
import script from "./AddIssue.vue?vue&type=script&lang=js&"
export * from "./AddIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports